import { Injectable } from '@angular/core';
import { ClienteEntity, CodigoClienteEntity } from '@domain/dto/cliente/cliente-get.dto';
import { ClientePostDto } from '@domain/dto/cliente/cliente-post.dto';
import { PersonUsecase } from '@domain/usecases/person/person-usecase';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PersonController {
  constructor(private usecaseService: PersonUsecase) {}

  getById(id: string, type: string): Observable<ClienteEntity> {
    return this.usecaseService.getById(id, type);
  }
  insert(param: any): Observable<any> {
    return this.usecaseService.insert(param);
  }
  update(param: ClientePostDto): Observable<ClientePostDto> {
    return this.usecaseService.update(param);
  }
  getByCpfOrPass(id: string, type: string): Observable<CodigoClienteEntity> {
    return this.usecaseService.getByCpfOrPass(id, type);
  }
}
